import React, { FC, MouseEvent } from "react";

import { ItsMeLogo } from "@/assets/images";

import { StyledItsMeBtn, StyledItsMeTxt } from "./styled";

type ItsMeButtonProps = {
    label: string;
    className?: string;
    dataTestId?: string;
    disabled?: boolean;
    onClick: (event: MouseEvent) => void;
};

const ItsMeButton: FC<ItsMeButtonProps> = ({ disabled = false, className, onClick, dataTestId, label }) => {
    return (
        <StyledItsMeBtn className={className} disabled={disabled} onClick={onClick} fullWidth data-testid={dataTestId}>
            <ItsMeLogo />
            <StyledItsMeTxt>{label}</StyledItsMeTxt>
        </StyledItsMeBtn>
    );
};

export default ItsMeButton;
